<template>
  <span class="icon" v-html="icon" />
</template>

<script setup lang="ts">
/**
 * name: svg文件的名字
 */
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
})

const icon = ref('')

watchEffect(async () => {
  try {
    const iconsImport = import.meta.glob('assets/icons/**/**.svg', {
      as: 'raw',
      eager: false,
    })
    const rawIcon = await iconsImport[`/assets/icons/${props.name}.svg`]()
    icon.value = rawIcon
  } catch {
    console.error(`[nuxt-icons] Icon '${props.name}' doesn't exist in 'assets/icons'`)
  }
})
</script>

<style lang="less" scoped>
.icon {
  display: inline-flex;
  align-items: center;
  width: 22px;
  height: 22px;
}
</style>
